import { Pipe, PipeTransform } from '@angular/core';

import { PortfolioUtil } from '../utils';

@Pipe({
	name: 'portfolioName'
})
export class PortfolioNamePipe implements PipeTransform {

	/**
	 * Returns the portfolio name by calling getPortfolioName in PortfolioUtil.
	 * If the provided portfolio does not have a name, 'No Name' value is returned.
	 *
	 * @param portfolio
	 */

	public transform(portfolio: any): unknown {
		return PortfolioUtil.getPortfolioName(portfolio);
	}

}
